import { call, put, takeEvery } from 'redux-saga/effects';
import { DeleteCashDiscount, ProgramActionKeys, programsActionCreators } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../programsApi';

function* deleteCashDiscountSaga(action: DeleteCashDiscount) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone = yield call(api.deleteCashDiscount, action.payload.programCashDiscountId);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else {
    yield put(programsActionCreators.removeCashDiscount(action.payload.programCashDiscountId));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteCashDiscount() {
  yield takeEvery(ProgramActionKeys.DELETE_CASH_DISCOUNT, deleteCashDiscountSaga);
}
